import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Col, Input, Row, Spin } from "antd";
import AWS from "aws-sdk";

import Swal from "sweetalert2";

import commentApi from "../../../apis/Comment.api";
import { isEndWithConsonant } from "../../../utils/status";
import { loginAlert, toastAlert } from "../../AlertComponent";
import LoginComponent from "../login/LoginComponent";

import ChannelCommentList from "./ChannelCommentList";
import CommentImagePreviewGroup from "./CommentImagePreviewGroup";
import CommentImageUpload from "./CommentImageUpload";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const ChannelCommentComponent = ({
	detail,
	type,
	getCommunity,
	getCommunityList,
	whereShow,
}) => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	// const user = useSelector(state => state.auth.user)

	const obsRef = useRef(null); //observer Element
	const preventRef = useRef(true); //옵저버 중복 실행 방지
	const endRef = useRef(false); //모든 글 로드 확인

	const [blurShow, setBlurShow] = useState(false);

	// const [popoverOpen, setPopoverOpen] = useState(false);

	const [comLoading, setComLoading] = useState(false);

	const [commentObj, setCommentObj] = useState({
		content: "",
		phone: "",
		phone_valid: "",
		password: "",
		password_valid: "",
		is_secret: false,
		is_alert: true,
	});

	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);
	// const [biggestTitle, setBiggestTitle] = useState(0);
	const biggestTitle = 0;

	const [pageSize, setPageSize] = useState(5);
	// const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [commentCount, setCommentCount] = useState(0);
	const [allCount, setAllCount] = useState(0);

	const [commentList, setCommentList] = useState([]);

	const [findComment, setFindComment] = useState(false);

	useEffect(() => {
		if (detail?.id) {
			if (findComment) {
				getFindComment();
			} else {
				getCommentList();
			}
		}
	}, [cUser, detail, findComment]);

	useEffect(() => {
		const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 });
		if (obsRef.current) observer.observe(obsRef.current);
		return () => {
			observer.disconnect();
		};
	});

	const obsHandler = (entries) => {
		//옵저버 콜백함수
		const target = entries[0];
		if (
			!endRef.current &&
			target.isIntersecting &&
			preventRef.current &&
			cUser?.id
		) {
			//옵저버 중복 실행 방지
			preventRef.current = false; //옵저버 중복 실행 방지
			if (commentCount >= pageSize) {
				setPageSize((prev) => prev + 5); //페이지 값 증가
			} else {
				endRef.current = true;
			}
		}
		// console.log(!endRef.current, target.isIntersecting, preventRef.current);
	};

	useEffect(() => {
		if (detail?.id) {
			getList();
		}
	}, [pageSize]);

	/**
	 * 댓글 무한 스크롤 적용
	 * @type {(function(): Promise<void>)|*}
	 */
	const getList = useCallback(async () => {
		if (findComment) {
			let param = {
				// ...userObj,
				// offset: (currentPageNumber - 1) * pageSize,
				offset: 0,
				pageSize: pageSize,
				influencerId: reduxChannel?.user_id,
				boardId: detail?.id,
				pageType: type,
				userId: cUser?.id,
			};
			const res = await commentApi.readCommentByUser(param);
			if (res.code === 200) {
				setCommentList(res.result?.commentDTOList ?? []);
				// setAllCount(res.result?.totalCnt);
				// setCommentCount(res.result?.totalCommentCnt);
				setComLoading(false);
				if (!findComment) {
					setFindComment(true);
				}
				preventRef.current = true;
				endRef.current = false;
			} else {
				setComLoading(false);
			}
		} else {
			setComLoading(true);
			const param = {
				// offset: (currentPageNumber - 1) * pageSize,
				offset: 0,
				pageSize: pageSize,
				influencerId: reduxChannel?.user_id,
				boardId: detail?.id,
				pageType: type,
				userId: cUser?.id ?? null,
			};
			const res = await commentApi.readComment(param);
			if (res.code === 200) {
				setCommentList(res.result?.commentDTOList ?? []);
				// setAllCount(res.result?.totalCnt);
				// setCommentCount(res.result?.totalCommentCnt);
				setComLoading(false);
				preventRef.current = true;
				endRef.current = false;
			} else {
				setComLoading(false);
			}
		}
	}, [pageSize, findComment]);

	useEffect(() => {
		if (detail?.comment_num !== allCount) {
			if (getCommunity) {
				getCommunity();
			}
			if (getCommunityList) {
				getCommunityList();
			}
		}
	}, [allCount]);

	/**
	 * 초기화
	 */
	const initializeComment = () => {
		setCommentObj({
			content: "",
			phone: "",
			phone_valid: "",
			password: "",
			password_valid: "",
			is_secret: false,
			is_alert: true,
		});
		setFindComment(false);
		setImageList([]);
		setPhotoList([]);
	};

	/**
	 * 댓글 작성 valid control
	 * @param e
	 */
	const handleComment = (e) => {
		let { name, value } = e.target;
		let phone = value?.replaceAll(/[^0-9]/g, "");
		if (cUser?.id) {
			// 휴대폰 번호 밸리데이션
			if (name === "phone" || name === "phone_valid") {
				if (value?.length <= 11) {
					setCommentObj({
						...commentObj,
						[name]: phone,
					});
				}
			} else {
				setCommentObj({
					...commentObj,
					[name]: value,
				});
			}
		} else {
			loginAlert({ history, reduxChannel });
		}
	};

	/**
	 * 댓글 작성하기 - 제출
	 */
	const submitComment = async () => {
		if (cUser?.id) {
			if (commentObj?.content?.trim()?.length) {
				const param = {
					board_id: detail?.id,
					influencer_id: reduxChannel?.user_id,
					category_type: type,
					// phone: commentObj.phone,
					// password: commentObj.password,
					content: commentObj.content,
					is_secret: commentObj.is_secret,
					is_alert: commentObj.is_alert,
					created_by: cUser?.id,
					is_influencer: !!cUser?.is_influencer,
				};
				setComLoading(true);
				const res = await commentApi.createComment(param);
				if (res.code === 200) {
					updateImageList(res.result);
				} else {
					setComLoading(false);
				}
			} else {
				toastAlert("댓글을 작성해주세요.");
			}
		} else {
			loginAlert({ history, reduxChannel });
		}
	};

	/**
	 * 댓글 목록 가져오기
	 * @returns {Promise<void>}
	 */
	const getCommentList = async () => {
		setComLoading(true);
		const param = {
			// offset: (currentPageNumber - 1) * pageSize,
			offset: 0,
			pageSize: pageSize,
			influencerId: reduxChannel?.user_id,
			boardId: detail?.id,
			pageType: type,
			userId: cUser?.id ?? null,
		};
		const res = await commentApi.readComment(param);
		if (res.code === 200) {
			setCommentList(res.result?.commentDTOList ?? []);
			setAllCount(res.result?.totalCnt);
			setCommentCount(res.result?.totalCommentCnt);
			setComLoading(false);
			preventRef.current = true;
			endRef.current = false;
		} else {
			setComLoading(false);
		}
	};

	/**
	 * 내가 남긴 댓글 찾기
	 * @returns {Promise<void>}
	 */
	const getFindComment = async () => {
		// setComLoading(true);
		let param = {
			// ...userObj,
			// offset: (currentPageNumber - 1) * pageSize,
			offset: 0,
			pageSize: pageSize,
			influencerId: reduxChannel?.user_id,
			boardId: detail?.id,
			pageType: type,
			userId: cUser?.id,
		};
		const res = await commentApi.readCommentByUser(param);
		if (res.code === 200) {
			setCommentList(res.result?.commentDTOList ?? []);
			setAllCount(res.result?.totalCnt);
			setCommentCount(res.result?.totalCommentCnt);
			setFindComment(true);
			setComLoading(false);
			preventRef.current = true;
			endRef.current = false;
		} else {
			setComLoading(false);
		}
	};

	/**
	 * 스크롤 이동
	 */
	const handleScrollTo = () => {
		const modal = document.getElementsByClassName("ant-modal-content");
		if (modal) {
			modal[0]?.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		}
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	/**
	 * 이미지 삭제 (목록에서 제거 -> 작성/수정완료 클릭 시 적용)
	 * @param idx
	 */
	const onDeleteImage = (idx) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let list = [...imageList];
				let photos = [...photoList];
				list.splice(idx, 1);
				photos.splice(idx, 1);
				setImageList(list);
				setPhotoList(photos);
			}
		});
	};

	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const updateImageList = async (result) => {
		let list = [];
		for (let i = 0; i < photoList?.length; i++) {
			let photo = photoList[i];

			// 등록
			if (photo?.file) {
				uploadToS3(result, photo, i);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
			// 수정
			else {
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: photo?.title ?? `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
		}

		const param = {
			target_id: result?.id,
			target_type: "comment",
			created_by: cUser?.id,
			imageList: [...list],
		};
		const res = await commentApi.postCommentImage(param);
		if (res.code === 200) {
			const timer = setTimeout(() => {
				Swal.fire({
					customClass: "alert-custom",
					text: "성공적으로 등록되었습니다!",
					confirmButtonText: "확인",
				}).then(() => {
					getCommentList();
					initializeComment();
				});
			}, 1500);
			return () => clearTimeout(timer);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("comment-image-list-error");
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param result
	 * @param photo
	 * @param i
	 * @returns {Promise<void>}
	 */
	const uploadToS3 = async (result, photo, i) => {
		let fileType = photo?.type?.split("/")[1];
		let s3Path = `image/together/comment/${reduxChannel?.user_id}/${
			result?.id
		}-${biggestTitle + i + 1}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("comment-s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("comment-s3-upload-error");
				setComLoading(false);
			});
		}
	};

	return (
		<div className={`product-each comment-div`} id={`comment-div`}>
			{/* 댓글 달기 */}
			{!whereShow && (
				<div className={`comment-title-div`}>
					<h3 className={`body-title`}>댓글달기</h3>

					{cUser?.id && (
						<>
							{/*{findComment ? (*/}
							<Button
								className={`comment-my-button ${findComment ? "active" : ""}`}
								loading={comLoading}
								onClick={() => {
									if (!findComment) {
										setFindComment(true);
										// setCurrentPageNumber(1);
									} else {
										setFindComment(false);
										// setCurrentPageNumber(1);
									}
								}}
							>
								내가 남긴 댓글
							</Button>
						</>
					)}
				</div>
			)}

			{/* 댓글 달기 comment 입력, 제출 버튼, 비밀글 */}
			<div className={`comment-register-div`}>
				<Col>
					<div className={`comment-textarea-div`}>
						<Input.TextArea
							placeholder={`댓글을 남겨주세요.\nex) 오메가3 제품과 함께 먹으면 좋을 영양제 알려주세요`}
							value={commentObj?.content}
							name={`content`}
							onChange={handleComment}
							disabled={comLoading}
							// onFocus={() => setCommentShow(true)}
							// onBlur={() => setCommentShow(false)}
						/>
					</div>

					{/* 업로드한 이미지 보기 */}
					{!!imageList?.length && (
						<CommentImagePreviewGroup
							imageList={imageList}
							onDeleteImage={onDeleteImage}
							loading={comLoading}
						/>
					)}

					<Row
						className={`secret-button-group`}
						// style={commentShow ? {height: "auto", overflow: "hidden"} : {height: 0, overflow: "hidden"}}
					>
						{/* 댓글 이미지 업로드 */}
						<CommentImageUpload
							imageList={imageList}
							setImageList={setImageList}
							photoList={photoList}
							setPhotoList={setPhotoList}
							comLoading={comLoading}
						/>
						<div
							className={`secret-button-wrap`}
							onClick={() => {
								if (!comLoading) {
									if (cUser?.id) {
										setCommentObj({
											...commentObj,
											is_secret: !commentObj.is_secret,
										});
									} else {
										loginAlert({ history, reduxChannel });
									}
								}
							}}
						>
							<img
								src={`/assets/images/login/check${
									commentObj.is_secret ? "-active" : ""
								}.png`}
								alt={`비밀글`}
								style={{
									height: "auto",
									width: "1.2em",
								}}
							/>
							{/*비밀글로 작성하기*/}
							비밀글
						</div>
						<Button onClick={submitComment} disabled={comLoading}>
							댓글 달기
						</Button>
					</Row>
					<p
						style={{
							fontSize: "0.9em",
							color: "#6d7580",
							letterSpacing: "-0.5px",
						}}
					>
						* 이미지는 최대 1장까지 가능합니다.
					</p>
				</Col>
			</div>
			<div
				className={`${cUser?.id ? "" : "comment-blur"} ${
					!blurShow ? "" : "blur-show"
				}`}
				style={{ display: "block" }}
			>
				{!cUser?.id && (
					<div className={`blur-div`}>
						{!blurShow ? (
							<div className={`blur-login-modal`}>
								<p className={`login-modal-info`}>
									휴대폰 번호로 로그인하고{"\n"}
									{reduxChannel?.name}
									{isEndWithConsonant(reduxChannel?.name) ? "과" : "와"}{" "}
									소통해보세요
								</p>
								<Button
									className={`blur-login-button`}
									onClick={() => setBlurShow(true)}
								>
									로그인하고 소통하기
								</Button>
							</div>
						) : (
							<div className={`blur-login-modal`} style={{ width: "100%" }}>
								<img
									src={`/assets/images/channel/close.png`}
									alt={`추가`}
									className={`blur-login-close`}
									onClick={() => setBlurShow(false)}
								/>
								<p className={`blur-login-title`}>로그인/회원가입하기</p>
								<LoginComponent />
							</div>
						)}
					</div>
				)}

				{/* 댓글 리스트 */}
				<ChannelCommentList
					type={type}
					total={allCount}
					commentList={commentList}
					getCommentList={getCommentList}
					getFindComment={getFindComment}
					comLoading={comLoading}
					setComLoading={setComLoading}
					findComment={findComment}
					setFindComment={setFindComment}
					// currentPageNumber={currentPageNumber}
				/>
				{/*{comLoading && (*/}
				{/*    <Spin style={{*/}
				{/*        position: "fixed", margin: "auto", width: "100%",*/}
				{/*        left: 0, right: 0, bottom: "2em"*/}
				{/*    }}/>*/}
				{/*)}*/}

				{!!cUser?.id && (
					<>
						{commentList?.length ? (
							// <Pagination
							//     className="report-pagination-wrap"
							//     showSizeChanger={false}
							//     current={currentPageNumber}
							//     pageSize={pageSize}
							//     total={commentCount}
							//     onChange={handleChangePagination}
							// />
							<></>
						) : (
							<Row
								align={"middle"}
								style={{
									width: "100%",
									flexDirection: "column",
									padding: "3em 0",
								}}
							>
								<img
									src={`/assets/images/warning.png`}
									alt={`warning-icon`}
									style={{
										width: "3em",
										height: "auto",
									}}
								/>
								<p
									style={{
										marginTop: "1em",
										color: "#adb5bd",
										fontSize: "1.1em",
										fontWeight: 500,
									}}
								>
									등록된 댓글이 없습니다.
								</p>
							</Row>
						)}
					</>
				)}
				{comLoading && !!commentList?.length && (
					<Spin
						style={{
							// position: "fixed",
							paddingTop: "2em",
							margin: "auto",
							width: "100%",
							left: 0,
							right: 0,
							bottom: "2em",
						}}
					/>
				)}
			</div>
			{!comLoading &&
				commentCount < pageSize &&
				!!commentList?.length &&
				cUser?.id && (
					<button
						style={{
							width: "100%",
							color: "#868e96",
							padding: "2em",
							backgroundColor: "inherit",
						}}
						onClick={() => {
							handleScrollTo();
						}}
					>
						마지막 댓글입니다. 맨 위로 올라가기
					</button>
				)}
			<div
				ref={obsRef}
				style={{
					height: 30,
				}}
			/>
		</div>
	);
};
export default ChannelCommentComponent;
